import { ParamsBuilder, RowState } from "../types";
import { helper } from "./helper";

const normalizeBetween = (startValue?: string, endValue?: string) => {
  if (!startValue || !endValue) return undefined;
  const start = new Date(startValue);
  const end = new Date(endValue);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return undefined;
  const [minRaw, maxRaw] = start <= end ? [start, end] : [end, start];
  const min = new Date(minRaw);
  min.setHours(0, 0, 0, 0);
  const max = new Date(maxRaw);
  max.setHours(23, 59, 59, 999);
  return { min, max };
};

export class DatetimeBuilder implements ParamsBuilder {
  build(row: RowState): object {
    try {
      const baseDate = new Date(row.value);
      if (Number.isNaN(baseDate.getTime())) return {};

      const dayStart = new Date(baseDate);
      dayStart.setHours(0, 0, 0, 0);
      const dayEnd = new Date(baseDate);
      dayEnd.setHours(23, 59, 59, 999);

      switch (row.operator) {
        case "on":
          return {
            [row.fieldName]: helper(
              { gte: dayStart.toISOString(), lt: dayEnd.toISOString() },
              { multiTableSearch: row.multiTableSearch }
            )
          };
        case "after":
          return {
            [row.fieldName]: helper(
              { gte: dayStart.toISOString() },
              { multiTableSearch: row.multiTableSearch }
            )
          };
        case "before":
          return {
            [row.fieldName]: helper(
              { lt: dayStart.toISOString() },
              { multiTableSearch: row.multiTableSearch }
            )
          };
        case "between": {
          const normalized = normalizeBetween(row.value, row.value2);
          if (!normalized) return {};
          return {
            [row.fieldName]: helper(
              { gte: normalized.min.toISOString(), lt: normalized.max.toISOString() },
              { multiTableSearch: row.multiTableSearch }
            )
          };
        }
        default:
          return {};
      }
    } catch {
      return {};
    }
  }
}
